import React, { Fragment } from "react";

const SortHeaderComponent = (props) => {
    const onClickSortChange = (sortBy) => {
        var sortOrder = "ASC";
        if(props.filter.sortBy === sortBy) {
            if(props.filter.sortOrder === "ASC") {
                sortOrder = "DESC"
            }
        }

        props.onSortChange(sortBy, sortOrder);
    }

    return(
        <Fragment>
            <div className="text-nowrap" style={{cursor:"pointer"}} onClick={() => onClickSortChange(props.column)}>
                <span
                    className={`me-1 ${props.filter.sortOrder === "DESC" ? "ri-sort-desc" : "ri-sort-asc"} ${props.filter.sortBy === props.column ? "text-primary" : "text-light"}`}
                ></span>{props.title}
            </div>
        </Fragment>
    );
};

export default SortHeaderComponent;